<template>
    <div class="panel">
        <div class="panel-head">
            <div>
                <div class="panel-title">Sale Channels</div>
            </div>
        </div>

        <div v-if="!channels.length" class="empty-state">No sales data yet</div>

        <template v-else>
            <div class="donut-row">
                <div class="donut-wrap">
                    <canvas ref="canvas"></canvas>
                </div>

                <div class="channel-list">
                    <div class="channel-item" v-for="ch in channels" :key="ch.name">
                        <div class="name"><span class="swatch" :style="{ background: ch.color }"></span>{{ ch.name }}
                        </div>
                        <div class="pct">{{ ch.pct }}%</div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import Chart from 'chart.js'

export default {
    props: {
        channels: { type: Array, default: () => [] }
    },
    data() {
        return { chart: null }
    },
    mounted() {
        if (this.channels.length) this.renderChart();
    },
    beforeDestroy() {
        if (this.chart) this.chart.destroy();
    },
    watch: {
        channels() {
            this.$nextTick(() => {
                if (this.channels.length) this.renderChart();
            });
        }
    },
    methods: {
        renderChart() {
            if (this.chart) this.chart.destroy();

            this.chart = new Chart(this.$refs.canvas, {
                type: 'doughnut',
                data: {
                    labels: this.channels.map(c => c.name),
                    datasets: [{
                        data: this.channels.map(c => c.pct),
                        backgroundColor: this.channels.map(c => c.color),
                        borderWidth: 0
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    cutout: '72%',
                    cutoutPercentage: 72, // Chart.js v2 fallback
                    legend: { display: false }, // Chart.js v2 fallback
                    plugins: {
                        legend: { display: false }, // Chart.js v3/v4
                        tooltip: { enabled: true }
                    }
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.panel {
    background: var(--surface);
    border: 1px solid var(--line);
    border-radius: var(--radius);
    box-shadow: var(--shadow);
    padding: 1.25rem 1.4rem;
    height: 100%;
}


.panel-title {
    font-size: .95rem;
    font-weight: 700;
}

.panel-head {
    margin-bottom: 1rem;
}

.empty-state {
    font-size: .78rem;
    color: var(--ink-faint);
    padding: .75rem 0;
}

.donut-row {
    display: flex;
    align-items: center;
    gap: 1.25rem;
    flex: 1;
    min-height: 0;
}

.donut-wrap {
    position: relative;
    width: 150px;
    height: 150px;
    flex-shrink: 0;
}

.channel-list {
    display: flex;
    flex-direction: column;
    gap: .65rem;
    flex: 1;
    min-width: 0;
}

.channel-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: .5rem;
    font-size: .78rem;

    .name {
        display: flex;
        align-items: center;
        gap: .5rem;
        font-weight: 600;
        color: var(--ink);
        min-width: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .swatch {
        width: 9px;
        height: 9px;
        border-radius: 2px;
        flex-shrink: 0;
    }

    .pct {
        font-family: 'IBM Plex Mono', monospace;
        font-weight: 600;
        flex-shrink: 0;
    }
}
</style>


// WEBPACK FOOTER //
// channelMix.vue?6d578b5a